import { MobileBookingTotals } from "./MobileBookingTotals"
import { AvailabilityContinueLabel } from "./StatusMessages"

type Props = {
    amountPence?: number
    deliveryPence?: number | null
    showDelivery?: boolean
    hireLabel?: string
    checking?: boolean
    disabled?: boolean
    loading?: boolean
    onContinue?: () => void
}

export function SelectionFooter({ amountPence, deliveryPence = null, showDelivery = false, hireLabel, checking = false, disabled = true, loading = false, onContinue }: Props) {
    return <div className="ah-mobile-bar ah-mobile-selection-footer">
        <MobileBookingTotals label="Hire cost" amountPence={amountPence} deliveryPence={deliveryPence} showDelivery={showDelivery} hireLabel={hireLabel} loading={loading} />
        <button type="button" className="ah-primary-button ah-selection-continue" disabled={disabled} aria-busy={checking} onClick={onContinue}><AvailabilityContinueLabel checking={checking} /></button>
    </div>
}
